module.exports = __webpack_public_path__ + "media/photon_of_fluctuation.2d2b1503.mp3";